import { Dispatch, SetStateAction } from 'react';
import info from '../../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../components/FilterRadioButtonsContainer';
import { Container, Group } from '../../styles';

interface FinancialSettingsTabI {
  geraNFSeparada: boolean;
  setGeraNFSeparada: Dispatch<SetStateAction<boolean>>;
  geraNFSeparadaMatriz: boolean;
  isFilial: boolean;
}

export default function FinancialSettingsTab({
  geraNFSeparada,
  setGeraNFSeparada,
  geraNFSeparadaMatriz,
  isFilial,
}: FinancialSettingsTabI) {
  const isDisabled = isFilial && geraNFSeparadaMatriz;

  return (
    <Container>
      <div className="card-title">
        Financeiro
      </div>

      <Group>
        <div className="title">
          <div>
            Gera Nota Fiscal Separada?
            {' '}
            <img
              src={info}
              alt="info"
              title={
                isDisabled
                  ? 'A empresa Matriz possui NF Separada habilitada, portanto todas as filiais emitirão NF no próprio CNPJ. Esta opção não pode ser alterada.'
                  : 'Quando habilitado, os valores dos serviços serão emitidos em NF no CNPJ desta empresa. Quando desabilitado para uma filial, os valores serão emitidos na NF da Matriz.'
              }
            />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton
            selected={geraNFSeparada}
            onClick={() => !isDisabled && setGeraNFSeparada(true)}
            disabled={isDisabled}
          >
            Sim
          </FilterRadioButton>
          <FilterRadioButton
            selected={!geraNFSeparada}
            onClick={() => !isDisabled && setGeraNFSeparada(false)}
            disabled={isDisabled}
          >
            Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
        {isDisabled && (
          <strong>
            A Matriz desta empresa possui NF Separada habilitada. Todas as filiais emitirão NF no próprio CNPJ e esta configuração não pode ser alterada individualmente.
          </strong>
        )}
      </Group>
    </Container>
  );
}
